import React, { createContext, useContext, useState } from "react";
import { toast } from 'react-toastify';
import { fetchAIAddonCallTemplateTableAndFilterSchema } from "model/AIAddonCallTemplateModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const AIAddonCallTemplateContext = createContext();

export const AIAddonCallTemplateProvider = ({ children }) => {
    const { fetchMetadataSchema } = useCommonFilterOptions();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [aiAddonCallTemplateContextData, setAIAddonCallTemplateContextData] = useState();

    const fetchAIAddonCallTemplateContextData = async () => {
        setLoading(true);
        try {
            const response = await fetchMetadataSchema("metadata:aiAddonCallTemplate", () =>
                fetchAIAddonCallTemplateTableAndFilterSchema([])
            );
            if (response?.success) {
                setAIAddonCallTemplateContextData(response?.data);
            }
        } catch (err) {
            toast.error(err);
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <AIAddonCallTemplateContext.Provider
            value={{
                fetchAIAddonCallTemplateContextData,
                aiAddonCallTemplateContextData,
                loading,
                error,
            }}
        >
            {children}
        </AIAddonCallTemplateContext.Provider>
    );
};

export const useAIAddonCallTemplateContext = () => useContext(AIAddonCallTemplateContext);
